export default "__VITE_ASSET__b4f9d65c__"